<template>
  <div
    v-if="visible"
    class="sp-finder-map-bounds map-bounds-scoping-overlay"
    style="position: absolute; top: 0; left: 50%; transform: translateX(-50%)"
  >
    <span class="icon-container icon-container--manual"><i class="icon"></i></span>
    <sp-button
      variant="text"
      color="custom"
      class="finder-result-control sp-finder-map-bounds__apply status-text status-text--manual"
      :data-testid="TestId.finder.mapBoundsSearch"
      @click="apply"
    >
      {{ mapText("search_area") }}
    </sp-button>
  </div>
</template>

<script setup>
import { TestId } from "#/test-ids";
import { mapText } from "#ce/apps/SpFinderMap/lib/map-text";
import { useFinderMapBoundsControl } from "#ce/apps/SpFinderMap/composables/useFinderMapBoundsControl";
const props = defineProps({ viewport: { type: Object, required: true }, enabled: Boolean });
const { visible, apply } = useFinderMapBoundsControl(props);
</script>
